import React, { useEffect, useState } from "react";
import "./UserDashboard.css";
import { FaUsers, FaCoins } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Api } from "../../../Admin/BackendApi/api";
import { APP_VERSION } from "../../../Admin/Pages/Version Provider/VersionConfig";
import ConfirmPopup from "../../../Admin/Component/ConfirmPopup/ConfirmPopup";

const UserDashboard = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);

    const [dashboardData, setDashboardData] = useState({
        totalReference: 0,
        balanceCoins: 0,
    });

    const [versionCode] = useState(APP_VERSION);

    const [popup, setPopup] = useState({
        show: false,
        message: "",
        type: "error",
    });

    const handlePopupClose = () => {
        setPopup({ ...popup, show: false });
    };

    const handleTotalRefClick = () => {
        navigate("/user/dashboard/references");
    };

    const handleViewBalanceClick = () => {
        navigate("/user/history");
    };

    const getDashboardData = async () => {
        try {
            setLoading(true);

            const token = localStorage.getItem("token");

            if (!token) {
                navigate("/user/login");
                return;
            }

            const res = await axios.post(
                Api.getUserDashboard,
                {
                    VersionCode: versionCode,
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                },
            );

            if (res.data.status === 0) {
                setPopup({
                    show: true,
                    message: (
                        <>
                            <span style={{ fontSize: "20px" }}>❌</span>{" "}
                            {res.data.message}
                        </>
                    ),
                    type: "error",
                });

                setLoading(false);
                return;
            }

            if (res.data.status === true || res.data.status === 1) {
                setDashboardData(res.data.data);
            }
        } catch (error) {
            console.log("Dashboard API Error:", error);

            setPopup({
                show: true,
                message: "Server error. Try again.",
                type: "error",
            });
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        getDashboardData();
    }, []);

    return (
        <div className="user-dashboard-container">
            <div className="user-dashboard-cards">
                <div
                    className="user-dashboard-card"
                    onClick={handleTotalRefClick}
                >
                    <div className="user-card-header">
                        <span className="user-card-icon purple">
                            <FaUsers />
                        </span>
                        <span className="user-card-title">Total Reference</span>
                    </div>

                    <h3 className="user-card-value">
                        {dashboardData.totalReference}
                    </h3>

                    <p className="user-card-subtext">
                        Last 6 months Active reference: <span>15</span>
                    </p>
                </div>

                <div
                    className="user-dashboard-card"
                    onClick={handleViewBalanceClick}
                >
                    <div className="user-card-header">
                        <span className="user-card-icon purple">
                            <FaCoins />
                        </span>
                        <span className="user-card-title">Balance Coins</span>
                    </div>

                    <h3 className="user-card-value">
                        {dashboardData.balanceCoins}
                    </h3>
                </div>
            </div>

            <ConfirmPopup
                show={popup.show}
                message={popup.message}
                type={popup.type}
                onClose={handlePopupClose}
            />
        </div>
    );
};

export default UserDashboard;
